// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Pervasives = require("@rescript/std/lib/js/pervasives.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");

function make(id) {
  return {
          id: id,
          input: /* Array */{
            _0: []
          }
        };
}

function makeWithInputArray(id, input) {
  return {
          id: id,
          input: /* Array */{
            _0: input
          }
        };
}

function toString(t) {
  return t.input._0.join(" ");
}

function newId(t, key) {
  var newId$1 = t.id + key;
  t.input._0.push(newId$1);
  return newId$1;
}

function registerNewIds(t, values) {
  return Belt_Array.map(values, (function (__x) {
                return newId(t, __x);
              }));
}

var AriaLabelledby = {
  make: make,
  makeWithInputArray: makeWithInputArray,
  toString: toString,
  newId: newId,
  registerNewIds: registerNewIds
};

function make$1(id) {
  return {
          id: id,
          input: /* Array */{
            _0: []
          }
        };
}

function toString$1(t) {
  return t.input._0.join(" ");
}

function newId$1(t, key) {
  var newId$2 = t.id + key;
  t.input._0.push(newId$2);
  return newId$2;
}

var AriaDescribedby = {
  make: make$1,
  toString: toString$1,
  newId: newId$1
};

var _map = {"Assertive":"assertive","Off":"off","Polite":"polite"};

var _revMap = {"assertive":"Assertive","off":"Off","polite":"Polite"};

function ariaLiveToJs(param) {
  return _map[param];
}

function ariaLiveFromJs(param) {
  return _revMap[param];
}

var _map$1 = {"Main":"main","ContentInfo":"contentinfo","Group":"group","Search":"search","Button":"button","Listbox":"listbox","Option":"option","Banner":"banner","Navigation":"navigation","Tooltip":"tooltip","Dialog":"dialog","Document":"document","Img":"img"};

var _revMap$1 = {"main":"Main","contentinfo":"ContentInfo","group":"Group","search":"Search","button":"Button","listbox":"Listbox","option":"Option","banner":"Banner","navigation":"Navigation","tooltip":"Tooltip","dialog":"Dialog","document":"Document","img":"Img"};

function roleToJs(param) {
  return _map$1[param];
}

function roleFromJs(param) {
  return _revMap$1[param];
}

var _map$2 = {"Listbox":"listbox"};

var _revMap$2 = {"listbox":"Listbox"};

function ariaHasPopupToJs(param) {
  return _map$2[param];
}

function ariaHasPopupFromJs(param) {
  return _revMap$2[param];
}

function makeDialog(ariaLabelledby) {
  return {
          ariaAtomic: undefined,
          ariaControls: undefined,
          ariaCurrent: undefined,
          ariaDescribedby: undefined,
          ariaDisabled: undefined,
          ariaExpanded: undefined,
          ariaHasPopup: undefined,
          ariaHidden: undefined,
          ariaLabel: undefined,
          ariaLabelledby: ariaLabelledby,
          ariaLive: undefined,
          ariaModal: true,
          ariaRoledescription: undefined,
          lang: undefined,
          role: "dialog",
          tabIndex: undefined
        };
}

var $$default = {
  ariaAtomic: undefined,
  ariaControls: undefined,
  ariaCurrent: undefined,
  ariaDescribedby: undefined,
  ariaDisabled: undefined,
  ariaExpanded: undefined,
  ariaHasPopup: undefined,
  ariaHidden: undefined,
  ariaLabel: undefined,
  ariaLabelledby: undefined,
  ariaLive: undefined,
  ariaModal: undefined,
  ariaRoledescription: undefined,
  lang: undefined,
  role: undefined,
  tabIndex: undefined
};

function view(param) {
  var ariaLabelledby = param.ariaLabelledby;
  var ariaDescribedby = param.ariaDescribedby;
  return {
          ariaControls: param.ariaControls,
          ariaCurrent: param.ariaCurrent,
          ariaDescribedby: ariaDescribedby !== undefined ? toString$1(Caml_option.valFromOption(ariaDescribedby)) : undefined,
          ariaDisabled: param.ariaDisabled,
          ariaExpanded: param.ariaExpanded,
          ariaHasPopup: param.ariaHasPopup,
          ariaHidden: param.ariaHidden,
          ariaLabel: param.ariaLabel,
          ariaLabelledby: ariaLabelledby !== undefined ? toString(Caml_option.valFromOption(ariaLabelledby)) : undefined,
          ariaLive: param.ariaLive,
          ariaModal: param.ariaModal,
          ariaRoledescription: param.ariaRoledescription,
          lang: param.lang,
          role: param.role,
          tabIndex: param.tabIndex
        };
}

function set(ariaAtomic, ariaControls, ariaCurrent, ariaDescribedby, ariaDisabled, ariaExpanded, ariaHidden, ariaLabel, ariaLabelledby, ariaLive, ariaRoledescription, lang, role, tabindex, t) {
  return {
          ariaAtomic: ariaAtomic !== undefined ? Pervasives.string_of_bool(ariaAtomic) : t.ariaAtomic,
          ariaControls: ariaControls,
          ariaCurrent: ariaCurrent !== undefined && ariaCurrent ? "true" : t.ariaControls,
          ariaDescribedby: ariaDescribedby,
          ariaDisabled: ariaDisabled,
          ariaExpanded: ariaExpanded !== undefined ? Pervasives.string_of_bool(ariaExpanded) : t.ariaExpanded,
          ariaHasPopup: t.ariaHasPopup,
          ariaHidden: ariaHidden !== undefined ? Pervasives.string_of_bool(ariaHidden) : t.ariaHidden,
          ariaLabel: ariaLabel,
          ariaLabelledby: ariaLabelledby,
          ariaLive: ariaLive !== undefined ? ariaLiveToJs(ariaLive) : t.ariaLive,
          ariaModal: t.ariaModal,
          ariaRoledescription: ariaRoledescription,
          lang: lang,
          role: role !== undefined ? roleToJs(role) : t.role,
          tabIndex: tabindex !== undefined ? String(tabindex) : (
              role === "Main" ? "-1" : t.tabIndex
            )
        };
}

function make$2(ariaAtomic, ariaControls, ariaCurrent, ariaDescribedby, ariaDisabled, ariaExpanded, ariaHidden, ariaLabel, ariaLabelledby, ariaLive, ariaRoledescription, lang, role, tabindex, param) {
  return set(ariaAtomic, ariaControls, ariaCurrent, ariaDescribedby, ariaDisabled, ariaExpanded, ariaHidden, ariaLabel, ariaLabelledby, ariaLive, ariaRoledescription, lang, role, tabindex, $$default);
}

var ariaLiveToString = ariaLiveToJs;

var roleToString = roleToJs;

var notFocusable = {
  ariaAtomic: undefined,
  ariaControls: undefined,
  ariaCurrent: undefined,
  ariaDescribedby: undefined,
  ariaDisabled: undefined,
  ariaExpanded: undefined,
  ariaHasPopup: undefined,
  ariaHidden: "true",
  ariaLabel: undefined,
  ariaLabelledby: undefined,
  ariaLive: undefined,
  ariaModal: undefined,
  ariaRoledescription: undefined,
  lang: undefined,
  role: undefined,
  tabIndex: "-1"
};

var defaultView = {
  ariaControls: undefined,
  ariaCurrent: undefined,
  ariaDescribedby: undefined,
  ariaDisabled: undefined,
  ariaExpanded: undefined,
  ariaHasPopup: undefined,
  ariaHidden: undefined,
  ariaLabel: undefined,
  ariaLabelledby: undefined,
  ariaLive: undefined,
  ariaModal: undefined,
  ariaRoledescription: undefined,
  lang: undefined,
  role: undefined,
  tabIndex: undefined
};

exports.AriaLabelledby = AriaLabelledby;
exports.AriaDescribedby = AriaDescribedby;
exports.ariaLiveToJs = ariaLiveToJs;
exports.ariaLiveFromJs = ariaLiveFromJs;
exports.roleToJs = roleToJs;
exports.roleFromJs = roleFromJs;
exports.ariaHasPopupToJs = ariaHasPopupToJs;
exports.ariaHasPopupFromJs = ariaHasPopupFromJs;
exports.ariaLiveToString = ariaLiveToString;
exports.roleToString = roleToString;
exports.notFocusable = notFocusable;
exports.makeDialog = makeDialog;
exports.$$default = $$default;
exports.default = $$default;
exports.__esModule = true;
exports.defaultView = defaultView;
exports.view = view;
exports.set = set;
exports.make = make$2;
/* No side effect */
